// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CloudDownload1Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "CloudDownload1/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2 9.5A3.5 3.5 0 0 0 5.5 13H9v2.586l-1.293-1.293a1 1 0 0 0-1.414 1.414l3 3a1 1 0 0 0 1.414 0l3-3a1 1 0 1 0-1.414-1.414L11 15.586V13h2.5a4.5 4.5 0 1 0-.615-8.958A4.002 4.002 0 1 0 5.13 6.019 3.5 3.5 0 0 0 2.001 9.5Zm9 3.5H9V8a1 1 0 0 1 2 0v5Z",
  clipRule: "evenodd"
}));
export default CloudDownload1Icon;